import { Box, IconButton, TableCell, TableRow, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { tableCellClasses } from '@mui/material/TableCell';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { toast } from 'react-toastify';
import { caloTheme } from 'src/theme/calo';

import { Currency } from '../../../lib/enum';
import { AffiliateCouponItem, AffiliateRes } from '../../../lib/types';
import { trackCodeCopied } from '../../../lib/mixpanel';
import ShareButton from './ShareButton';

interface AffiliateCouponRowProps {
  coupon: AffiliateCouponItem;
  currency?: Currency;
  affiliateId?: string;
  affiliate?: AffiliateRes;
}

const AffiliateCouponRow = ({ coupon, currency: _currency, affiliateId, affiliate }: AffiliateCouponRowProps) => {
  const StyledTableCell = styled(TableCell)(() => ({
    [`&.${tableCellClasses.head}`]: {
      color: '#6B7280',
      fontWeight: 400,
      fontSize: '14px'
    },
    [`&.${tableCellClasses.body}`]: {
      border: 'none',
      fontSize: '14px',
      color: '#111827',
      padding: '16px 8px'
    }
  }));

  const couponCode = coupon.couponDetails.couponCode.toUpperCase();

  const handleCopy = () => {
    navigator.clipboard.writeText(couponCode);
    toast.success('Code copied');

    if (affiliateId) {
      trackCodeCopied(affiliateId, couponCode, affiliate);
    }
  };


  return (
    <TableRow>
      <StyledTableCell>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography sx={{ fontWeight: 600, fontSize: '14px' }}>
            {couponCode}
          </Typography>
          <IconButton
            onClick={handleCopy}
            size="small"
            sx={{
              padding: '4px',
              color: caloTheme.palette.primary500,
              '&:hover': {
                backgroundColor: caloTheme.palette.primary50,
                color: caloTheme.palette.primary600
              }
            }}
          >
            <ContentCopyIcon sx={{ fontSize: '18px' }} />
          </IconButton>
        </Box>
      </StyledTableCell>
      <StyledTableCell>{coupon.totalUsersInvited}</StyledTableCell>
      <StyledTableCell>
        <ShareButton
          codeName={couponCode}
          affiliateId={affiliateId}
          affiliate={affiliate}
          variant="outlined"
          size="small"
        />
      </StyledTableCell>
    </TableRow>
  );
};

export default AffiliateCouponRow;

